import { type SelectHTMLAttributes, forwardRef } from 'react';
import clsx from 'clsx';

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  options: { value: string; label: string }[];
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(
  ({ label, options, className, ...props }, ref) => {
    return (
      <div className="flex items-center gap-2.5">
        {label && (
          <span className="text-sm text-text-muted font-body w-36 shrink-0">{label}</span>
        )}
        <select
          ref={ref}
          className={clsx(
            'w-full py-3.5 px-4 bg-input-bg border border-input-border rounded-[3px]',
            'text-text-bright text-md font-mono outline-none cursor-pointer',
            'disabled:opacity-50 disabled:cursor-not-allowed',
            className,
          )}
          {...props}
        >
          {options.map(o => (
            <option key={o.value} value={o.value}>{o.label}</option>
          ))}
        </select>
      </div>
    );
  },
);
Select.displayName = 'Select';
